import BaseView from 'picnic/core/views/Base';


class View extends BaseView {

	events() {
		return {
			'click .close': '_onClose'
		};
	}

	_onClose(e) {
		e.preventDefault();
		this.$el.addClass('is-hidden');
	}

}

export default View;
